import { render, staticRenderFns } from "./AccommodationsEditTable.vue?vue&type=template&id=8b6e4ec8&scoped=true&"
import script from "./AccommodationsEditTable.vue?vue&type=script&lang=js&"
export * from "./AccommodationsEditTable.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsEditTable.vue?vue&type=style&index=0&id=8b6e4ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e4ec8",
  null
  
)

export default component.exports